'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.isInvalidDeliveryInfo = isInvalidDeliveryInfo;
exports.getInvalidDeliveryInfos = getInvalidDeliveryInfos;
exports.fixInvalidDeliveryInfos = fixInvalidDeliveryInfos;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isInvalidDeliveryInfo(di) {
    var polygon = _lodash2.default.get(di, 'area.polygon');
    return polygon && polygon.length > 0 && _lodash2.default.find(polygon, function (latLng) {
        return latLng && !latLng.lat && !latLng.lng;
    });
}

function getInvalidDeliveryInfos(restaurant) {
    var deliveryInfos = _lodash2.default.get(restaurant, 'deliveryInfos') || [];
    return _lodash2.default.filter(deliveryInfos, isInvalidDeliveryInfo);
}

function fixInvalidDeliveryInfos(_ref) {
    var restaurant = _ref.restaurant,
        accessToken = _ref.accessToken,
        restClient = _ref.restClient;

    var deliveryInfos = _lodash2.default.reject(restaurant.deliveryInfos, isInvalidDeliveryInfo);
    var nextRestaurant = (0, _extends3.default)({}, restaurant, { deliveryInfos: deliveryInfos });
    delete nextRestaurant.modified;
    return restClient('/organizations/' + restaurant.id, 'put', nextRestaurant, { type: 'Bearer', credentials: accessToken });
}